import {
  authenticateBiometrics,
  closeWebApp,
  getInitData,
  getTelegramUser,
  hapticImpact,
  hapticNotify,
  initBiometrics,
  openExternalLink,
  openTelegramLink,
  readyAndExpand,
  requestBiometricAccess,
  saveBiometricToken,
  showAlert,
  showConfirm,
  wireSettingsButton,
} from '../lib/telegram.ts';

import type { Platform } from './types.ts';

export const createTelegramPlatform = (): Platform => ({
  kind: 'telegram',
  ready: readyAndExpand,
  close: () => { closeWebApp(); },
  initData: () => getInitData(),
  user: () => getTelegramUser(),
  onSettings: (handler) => wireSettingsButton(handler),
  haptic: (kind) => {
    if (kind === 'light' || kind === 'medium' || kind === 'heavy') hapticImpact(kind);
    else hapticNotify(kind);
  },
  openLink: (url) => { openExternalLink(url); },
  openBotLink: (url) => { openTelegramLink(url); },
  confirm: (message, done) => { showConfirm(message, done); },
  alert: (message) => { showAlert(message); },
  biometricState: () => initBiometrics(),
  biometricRequestAccess: (reason) => requestBiometricAccess(reason),
  biometricUnlock: (reason) => authenticateBiometrics(reason),
  secureSet: (token) => saveBiometricToken(token),
});
